// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import { findCbLogoFromType } from '../../../enums/CbLogoFromPan';
import { CARD_PRODUCTS } from '../../../enums/CardProducts';
// Lang
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * Render the card product
 * @param {string} cardType
 * @param {string} cardProduct
 * @returns {React.ReactNode} RenderCardProduct
 */
function RenderCardProduct({ cardType, cardProduct }) {

    // Constants
    const cbObject = cardType ? findCbLogoFromType(cardType) : null;
    const isProductInfoTranslated = cardProduct ? CARD_PRODUCTS.some(product => product.name === cardProduct) : false;

    return (
        cardType && cardProduct && cbObject && cbObject.tradeLogo ?
            <div className='flex flex-col items-center'>
                <div>
                    <img className='h-10 w-auto align-middle text-4xl mt-1max-w-24 max-h-10'
                        src={cbObject.tradeLogo}
                    />
                </div>
                <div className='text-center'>
                    {cbObject.tradeName ?
                        <small className='text-xs'>
                            <small className='block'>{cbObject.tradeName}</small>
                            <div className='text-xs'>
                                {isProductInfoTranslated ?
                                    <Entity entity={`card_product.${cardProduct}`} namespace={nsTerminal} />
                                    : cardProduct
                                }
                            </div>
                        </small>
                        : false}

                </div>
            </div>
            :
            // no tradeLogo found
            cardType && cardProduct && !cbObject.tradeLogo ?
                <div>
                    <div>
                        <div className='text-center'>
                            <div className='text-xs'>
                                {isProductInfoTranslated ?
                                    <Entity entity={`card_product.${cardProduct}`} namespace={nsTerminal} />
                                    : cardProduct
                                }
                            </div>
                        </div>
                    </div>
                </div>
                :
                // No cardProduct
                <div className='text-center align-middle'>
                    {'-'}
                </div>
    );
}

RenderCardProduct.propTypes = {
    cardType: PropTypes.string,
    cardProduct: PropTypes.string
};

export default RenderCardProduct;